module.exports = __webpack_public_path__ + "static/13-cabb4f3d3a25b2ba0d78d7a3ea95cd5e.jpeg";